'use client';

import { useState } from "react";
import useSearchModal, { SearchQuery } from "../hooks/useSearchModal";

const CATEGORIES_LIST = [
  { label: 'Todos', value: '' },
  { label: 'Axé', value: 'axe' },
  { label: 'Forró', value: 'forro' },
  { label: 'Vaqueijada', value: 'vaqueijada' },
  { label: 'Seresta', value: 'seresta' },
  { label: 'Soul', value: 'soul' },
  { label: 'Reggae', value: 'reggae' },
  { label: 'Lambada', value: 'lambada' },
  { label: 'Pisadinha', value: 'pisadinha' },
  { label: 'Bregão', value: 'brega' },
  { label: 'MPB', value: 'mpb' },
  { label: 'Jovem Guarda', value: 'jovemguarda' },
  { label: 'Sertanejo', value: 'sertanejo' },
  { label: 'Rock', value: 'rock' },
  { label: 'Samba', value: 'samba' },
  { label: 'Funk', value: 'funk' },
  { label: 'Gospel', value: 'gospel' },
];

const Categories = () => {
  const searchModal = useSearchModal();
  const [category, setCategory] = useState('');

  const _setCategory = (_category: string) => {
    setCategory(_category);

    const query: SearchQuery = {
      ...searchModal.query,
      category: _category,
    };

    searchModal.setQuery(query);
  };

  return (
    <div className="flex items-center gap-2 overflow-x-auto py-4 no-scrollbar">
      {CATEGORIES_LIST.map((item) => {
        const isSelected = category === item.value;

        return (
          <button
            key={item.value || 'all'}
            type="button"
            onClick={() => _setCategory(item.value)}
            className={`
              shrink-0 px-4 py-2 rounded-full text-xs font-medium transition-all duration-200 ease-in-out cursor-pointer
              ${
                isSelected
                  ? 'bg-neutral-900 text-white shadow-sm scale-105'
                  : 'bg-neutral-100 text-neutral-600 hover:bg-neutral-200 hover:text-neutral-900'
              }
            `}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
};

export default Categories;
